export const PAGE_TITLE = "National Calamities";
export const PAGE_SINGLE_TITLE = "National Calamity";
export const LINK_URL = "national-calamities";
export const SEARCH_TERMS = ["name", "meta_title"];
export const inputFields = {
  name: {
    type: "string",
    required: true,
    title: "Name",
    slug: true,
    inputType: "text",
  },

  content: {
    type: "html",
    required: false,
    title: "Content",
  },
  featured_image: {
    type: "file",
    required: false,
    title: "Image",
  },
  gallery: {
    type: "gallery",
    required: false,
    title: "Gallery",
  },
  meta_title: {
    type: "string",
    required: false,
    title: "Meta Title",
  },
  meta_description: {
    type: "text",
    required: false,
    title: "Meta Description",
  },
  slug: {
    type: "slug",
    required: false,
    targetField: "title",
    title: "Slug",
  },
};
export const initialValues = {
  name: "",
  content: "",
  meta_title: "",
  meta_description: "",
  slug: "",
};

export const view_all_table = [
  { name: "Name", value: "name" },

  { name: "Slug", value: "slug" },
];
